module.exports = __webpack_public_path__ + "media/Victory.744d0e43.ogg";